import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
  appRequestSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";

import Form from "./Form";

import "./styles.scss";

// Last fypn data-collection step: the bank account fypn will draw the loan
// payments from. Submitting here is what triggers accept_the_offer, so the
// routing/account numbers reach the approval submit on the backend.
class FypnBankDataForm extends Component {
  state = {
    additionalData: {},
    valid: false,
  };

  buildRequestBody = () => {
    const { additionalData } = this.state;
    const { appRequest, offer } = this.props;
    const additionalInfo = offer.additional_info_data || {};

    return {
      ...appRequest,
      ...offer,
      app_id: offer.app_id,
      additional_info_data: {
        ...additionalInfo,
        bankAccount: {
          // keeps bankName collected on the additional info step
          ...(additionalInfo.bankAccount || {}),
          routing: additionalData.routingNum,
          account: additionalData.accountNum,
          type: "checking",
        },
      },
    };
  };

  submitForm = (e) => {
    const { valid } = this.state;
    e.preventDefault();
    if (!valid) return;

    this.props.selectOffer({ selectedOffer: this.buildRequestBody() });
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid,
    });
  };

  render() {
    const { loading, activeStepData } = this.props;
    const { valid } = this.state;

    return (
      <div className="paypair-step-content">
        <div className="fypn-bank-data-form-container">
          <div className="fypn-bank-data-form">
            <div className="fypn-bank-data-form__header">
              <h2 className="fypn-bank-data-form__title">Bank Account</h2>
              <p className="fypn-bank-data-form__subtitle">
                Your loan payments will be made from this account.
              </p>
            </div>

            <div className="fypn-bank-data-form__body">
              {activeStepData && activeStepData.error && activeStepData.message && (
                <div className="fypn-bank-data-form__error-message">
                  {activeStepData.message || ""}
                </div>
              )}

              <Form onDataChange={this.setAdditionalData} />
            </div>

            <div className="fypn-bank-data-form__footer">
              <BlueBtn
                customClass="fypn-bank-data-form-submit-btn"
                disabled={!valid}
                loading={loading}
                onClick={this.submitForm}
              >
                Continue
              </BlueBtn>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  activeStepData: activeStepDataSelector()(state),
  appRequest: appRequestSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

FypnBankDataForm = connect(
  mapStateToProps,
  mapDistpatchToProps
)(FypnBankDataForm);

export default FypnBankDataForm;
